export const alertColorData =[
    {
        color:"secondary",
        title:"Secondary"
    },
    {
        color:"success",
        title:"Success"
    },
    {
        color:"info",
        title:"Info"
    },
    {
        color:"warning",
        title:"Warning"
    },
    {
        color:"danger",
        title:"Danger"
    },
    {
        color:"light",
        title:"White"
    },
    {
        color:"dark",
        title:"Dark"
    }
]

export const additionalAlertData = [
    {
        class: 'alert-light-primary',
        head: 'Please! Check your notifications',
        headclass: 'txt-primary',
        text: 'The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.',
        subtext: 'The emergency notification system is free and is available in all 50 states.',
    },
    {
        class: 'alert-light-secondary',
        head: 'Something went wrong! Please, chrome update.',
        headclass: 'txt-secondary',
        text: 'The duty of notification is imposed upon the head of the family, and also upon the medical practitioner who may be in attendance on the patient.',
        subtext: 'Whenever you need to, be sure to use margin utilities to keep things nice and tidy.',
    },
    {
        class: 'alert-light-success',
        head: 'Please! Hidden cameras were not installed.',
        headclass: 'txt-success',
        text: 'Due to increasingly accessible technology, hidden cameras have grown in popularity among regular people in recent years.',
        subtext: 'Consider moving clocks and plush animals from your area if you think they may be concealing cameras because they are both portable items.',
    }
]